/* eslint-disable */
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { MyDocumentsUi } from './ui';
import { useMyDocuments } from './useMyDocuments';
import { useContracts } from 'components/contracts';
import { useMyProfile } from 'components/my-profile/useMyProfile';

const MyDocumentsWithHandlers = withLoadingAndNoConnectionHandler(MyDocumentsUi);

export const MyDocuments: React.FC = () => {
    const { data, isLoading, loadingError } = useMyDocuments();
    const { data: contracts, isLoading: contractLoading, loadingError: contractError } = useContracts();
    const { data: myProfileData, isLoading: isLoadingProfile, loadingError: profileLoadingError } = useMyProfile();
    return <MyDocumentsWithHandlers 
    myProfileData={data} 
    customerType={myProfileData?.identification?.customerType} 
    contracts={contracts} 
    isLoading={isLoading || contractLoading || isLoadingProfile} 
    hasError={!!loadingError || !!contractError || !!profileLoadingError} />;
};
